import filterSuggestedProducts from './filterSuggestedProducts';
import {getCheckoutOrderManager} from 'cart-ui';

export default function getSuggestedProducts(categoryName, productCount, productIdsToFilterOut) {
    return new Promise((resolve, reject) => {
            getCheckoutOrderManager()
                .then((checkoutOrderManager) => checkoutOrderManager.getCurrentOrder())
                .then((order) => {
                    fetch(
                        '/api/suggested-products/cart-system/'
                        + encodeURIComponent(order.data.cartSystemId)
                        + '/product-category-name/' + encodeURIComponent(categoryName),
                        {credentials: 'same-origin'}
                    ).then((resp) => resp.json()).then(function (data) {
                        if (data) {
                            resolve(filterSuggestedProducts(
                                data, productCount, order.data.items, productIdsToFilterOut
                            ));
                        } else {
                            resolve([]);
                        }
                    });
                });
        }
    );
}
